import { cn } from '@/lib/utils';

export type SpinnerVariant = 'light' | 'dark';

interface SpinnerProps {
    variant?: SpinnerVariant;
    size?: number;
    className?: string;
}

export function Spinner({
    variant = 'light',
    size = 80,
    className,
}: SpinnerProps) {
    const isLight = variant === 'light';
    const trackFill = isLight
        ? 'rgba(255, 255, 255, 0.25)'
        : 'rgba(0, 0, 0, 0.25)';
    const arcFill = isLight ? '#FFFFFF' : '#000000';

    return (
        <div
            className={cn('inline-flex items-center justify-center', className)}
        >
            <svg
                width={size}
                height={size}
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM6.25385 40C6.25385 58.6375 21.3625 73.7462 40 73.7462C58.6375 73.7462 73.7462 58.6375 73.7462 40C73.7462 21.3625 58.6375 6.25385 40 6.25385C21.3625 6.25385 6.25385 21.3625 6.25385 40Z"
                    fill={trackFill}
                />
                <path
                    d="M47.3473 79.3194C41.5418 80.4043 35.568 80.19 29.8551 78.6921C24.1421 77.1942 18.8318 74.4498 14.3054 70.656C9.77901 66.8621 6.14891 62.113 3.67579 56.7497C1.20268 51.3864 -0.0520686 45.542 0.0016549 39.6361L6.25525 39.693C6.20992 44.6755 7.2685 49.6062 9.35495 54.1309C11.4414 58.6557 14.5039 62.6623 18.3226 65.863C22.1414 69.0637 26.6215 71.379 31.4412 72.6428C36.2609 73.9065 41.3007 74.0872 46.1986 73.172L47.3473 79.3194Z"
                    fill={arcFill}
                    className="animate-spin"
                    style={{ transformOrigin: '40px 40px' }}
                />
            </svg>
        </div>
    );
}
